<template>
    <div class="px-2">
        <v-row>
            <v-col>
                <v-text-field v-model="search" autofocus :label="$translate('Search')" append-icon="mdi-magnify" single-line hide-details color="zoezi-edit-color" @keydown.enter="setIfOne"/>
            </v-col>
        </v-row>
        <v-row v-for="(row, rowindex) in componentRows" :key="rowindex">
            <v-col :cols="12 / columns" v-for="component in row" :key="component.name">
                <v-hover v-slot="{hover}">
                    <v-card
                        width=200
                        :elevation="hover&&!disabled ? 24 : 6"
                        :class="selectedComponent == component.name || (hover&&!disabled) ? ['zoezi-edit-color'] : undefined"
                        @click="setComponent(component)"
                    >
                        <v-card-text justify="center" align="center" :class="(selectedComponent == component.name || hover) ? 'zoezi-edit-text-color' : undefined">
                            <v-icon :class="(selectedComponent == component.name || hover) ? 'zoezi-edit-text-color' : ''">{{component.zoezi.icon}}</v-icon><br>
                            <span>{{$translate(component.zoezi.title)}}</span>
                        </v-card-text>
                    </v-card>
                </v-hover>
            </v-col>
        </v-row>

        <h4 v-if="componentRows.length == 0" class="ma-4 text--secondary">{{$translate('Found no component')}}</h4>
    </div>
</template>

<script>
import components from '../component.js';
import {chunk, isFunction} from 'lodash';
export default {
    name: 'ComponentPalette',
    props: {
        component: {
            type: Object
        }
    },

    data: () => ({
        columns: 2,
        search: '',
        selectedComponent: null
    }),
    watch: {
        'component.$options.name': {
            immediate: true,
            handler() {
                this.selectedComponent = this.component.$options.name
            }
        }
    },
    computed: {
        config() {
            return this.component.$parent._props.config;
        },
        disabled() {
            return this.selectedComponent == 'zoezi-root';
            /*            let internal = components.getAllComponents().find(x => x.zoezi.internal && x.name == this.config.component);
            return !!internal;*/
        },
        components() {
            /*let internal = components.getAllComponents().find(x => x.zoezi.internal && x.name == this.config.component);
            if (internal) {
                return [internal];
            }*/

            let hasAddons = x => {
                if (!x.zoezi?.addon) {
                    return true;
                }

                return this.$store.state.settings.modules[x.zoezi.addon];
            }

            let hasCompatibleType = x => {
                const type = x.zoezi?.type || 'mb';
                return this.$root.homepage_type == type;
            }

            let hasCompatibleUiLibrary = x => {
                const uiLLibrary = x.zoezi?.ui;
                return !uiLLibrary || this.$root.siteconfig.uiLibrary == uiLLibrary;
            }

            let s = this.search.toLowerCase();
            return components.getComponents().filter(hasAddons).filter(hasCompatibleType).filter(hasCompatibleUiLibrary).filter(x => x.zoezi && x.zoezi.title && this.$translate(x.zoezi.title).toLowerCase().includes(s)).sort((a, b) => this.$translate(a.zoezi.title).localeCompare(this.$translate(b.zoezi.title)))
        },
        componentRows() {
            return chunk(this.components, this.columns);
        }
    },
    methods: {
        setComponent(component) {
            if (this.disabled) {
                return;
            }
            this.config.props = {};
            components.getComponentProps(component.name).forEach(prop => {
                if (prop.default && !prop.global) {
                    this.config.props[prop.name] = isFunction(prop.default) ? prop.default() : prop.default;
                }
            });
            if (!this.config.id) {
                this.config.id = '0'.repeat(8).replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);});
            }
            this.config.component = component.name;

            let c = components.getComponent(component.name);
            if (c.zoezi.getDefaultStyle) {
                this.config.style = Object.assign({}, c.zoezi.getDefaultStyle());
            }

            let wrapper = this.component.$parent;
            wrapper.save();
            wrapper.select();
            this.search = '';
            this.selectedComponent = component.name;
        },
        setIfOne() {
            if (this.components.length == 1) {
                this.setComponent(this.components[0]);
            }
        }
    }
}
</script>
